import {Component, OnInit} from '@angular/core';
import {ConfiguratorProviderService, SelectItem} from '@tj/tj-dmp-lib-api';
import {FormBuilder} from '@angular/forms';
import {AbstractEditorComponent} from '../abstract-editor.component';
import {ValidatorEditorService} from '../validator-editor.service';
import {FieldService} from '../../field/field.service';

@Component({
    selector: 'dmp-provider-editor',
    templateUrl: './provider-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class ProviderEditorComponent extends AbstractEditorComponent implements OnInit {
    items: SelectItem[] = [];

    constructor(protected providerService: ConfiguratorProviderService,
                protected fieldService: FieldService,
                protected fb: FormBuilder,
                protected validatorService: ValidatorEditorService) {
        super(fb, validatorService);
    }

    transformBeforeSave(value: any) {
        return value;
    }

    ngOnInit(): void {
        this.init();
        if (!this.fieldService.datastore) {
            return;
        }
        this.providerService.getAllProvidersUsingGET(this.fieldService.datastore).subscribe(res => {
            this.items = (res || []).map(p => ({label: `${p.name} (${p.code})`, value: p.code} as SelectItem));
            if (this.value && this.value !== 'null' && !this.items.some(i => i.value === this.value)) {
                this.dataNotFound.next(this.field);
            }
        });
    }
}
